// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PasswordOutlinedSvg from "@fishx/icons-svg/es/asn/PasswordOutlined";
import FishxIcon from '../components/FishxIcon';

var PasswordOutlined = function PasswordOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PasswordOutlinedSvg
  }));
};

PasswordOutlined.displayName = 'PasswordOutlined';
export default React.forwardRef(PasswordOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PasswordOutlined.js
// module id = 3749
// module chunks = 0